import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import Box from '@material-ui/core/Box'
import Hidden from '@material-ui/core/Hidden'
import Checkbox from 'ui/components/checkbox'
import IconButton from '@material-ui/core/IconButton'
import SvgIcon from '@material-ui/core/SvgIcon'
import { ReactComponent as IconDelete } from 'assets/icons/delete.svg'
import useStyles from './actionsStyles'

const Actions = ({ status, onBulkSelect, canDelete, onRemoveVendors }) => {
  const classes = useStyles()
  const handleRemoveVendors = useCallback(() => {
    onRemoveVendors()
  }, [onRemoveVendors])

  return (
    <>
      <Hidden smUp>
        <Box
          className={classes.actionsMobile}
          display="flex"
          alignItems="center"
        >
          <IconButton
            className={classes.actionsButton}
            aria-label="add"
            color="primary"
            disabled={canDelete}
            onClick={handleRemoveVendors}
          >
            <SvgIcon component={IconDelete} />
          </IconButton>
        </Box>
      </Hidden>
      <Hidden xsDown>
        <Box
          className={classes.actionsDesktop}
          mb={2}
          display="flex"
          alignItems="center"
        >
          <Box display="flex" alignItems="center">
            <Checkbox
              className={classes.actionsCheckbox}
              indeterminate={status === 'partial'}
              checked={status === 'full'}
              onClick={onBulkSelect}
            />
            <IconButton
              className={classes.actionsButton}
              aria-label="add"
              color="primary"
              disabled={canDelete}
              onClick={handleRemoveVendors}
            >
              <SvgIcon component={IconDelete} />
            </IconButton>
          </Box>
        </Box>
      </Hidden>
    </>
  )
}

Actions.propTypes = {
  status: PropTypes.oneOf(['partial', 'full', 'none']),
  onBulkSelect: PropTypes.func,
  canDelete: PropTypes.bool,
  onRemoveVendors: PropTypes.func,
}

export default Actions
